import { type AutocompleteRenderInputParams, TextField } from "@mui/material";

import { PathParser } from "@/shared/domain/topics";

import { MessagePathHelp } from "./MessagePathHelp";
import styles from "./PathSelector.module.css";

interface PathSelectorInputProps {
  hasExactMatch: boolean;
  inputValue: string;
  inputParams: AutocompleteRenderInputParams;
  isValid: boolean;
  label: string;
  selectorIsOpen: boolean;
}

function getInputColorHint({
  isValid,
  hasExactMatch,
}: {
  isValid: boolean;
  hasExactMatch: boolean;
}) {
  if (!isValid) {
    return "error";
  }

  if (hasExactMatch) {
    return "success";
  }

  return undefined;
}

export function PathSelectorInput({
  hasExactMatch,
  inputValue,
  inputParams,
  isValid,
  label,
  selectorIsOpen,
}: PathSelectorInputProps) {
  const placeholderExample = [
    "esc_status",
    PathParser.TOPIC_SEPARATOR,
    "esc[2:7]",
    PathParser.MESSAGE_PATH_SEPARATOR,
    "esc_power",
  ].join("");

  return (
    <TextField
      {...inputParams}
      color={getInputColorHint({ isValid, hasExactMatch })}
      error={!isValid}
      fullWidth
      InputProps={{
        ...inputParams.InputProps,
        className: styles.input,
        endAdornment: (
          <>
            {inputParams.InputProps.endAdornment}
            <MessagePathHelp show={inputValue.length > 0 && selectorIsOpen} />
          </>
        ),
      }}
      InputLabelProps={{
        ...inputParams.InputLabelProps,
        className: styles.input,
      }}
      label={label}
      placeholder={`e.g., ${placeholderExample}`}
    />
  );
}
